module.exports = __webpack_public_path__ + "img/bg4.bf7cceb3.png";